export enum QuotingActionTypes {
  DELETE_QUOTE = 'DELETE_QUOTE',
  RECEIVE_PART = 'RECEIVE_PART',
  RECEIVE_QUOTE = 'RECEIVE_QUOTE',
  RECEIVE_RO_BY_QUOTE = 'RECEIVE_RO_BY_QUOTE',
  SET_STATE = 'SET_STATE',
  UPDATE_CUSTOMER_RESPONSE = 'UPDATE_CUSTOMER_RESPONSE',
  RECEIVE_QUOTE_FAILED = 'RECEIVE_QUOTE_FAILED',
  UPDATE_QUOTE_TOTALS = 'UPDATE_QUOTE_TOTALS',
  SET_RECOMMENDATION_CHANGES = 'SET_RECOMMENDATION_CHANGES',
  RESET_RECOMMENDATION_CHANGES = 'RESET_RECOMMENDATION_CHANGES',
  RESET_HAS_APPROVAL_CHANGES = 'RESET_HAS_APPROVAL_CHANGES',
  RESET_ACTIVE_QUOTE = 'RESET_ACTIVE_QUOTE',
  FETCH_LABOR_RATES = 'FETCH_LABOR_RATES',
  RECEIVE_LABOR_RATES = 'RECEIVE_LABOR_RATES',
  SET_LABOR_RATES_RESPONSE = 'SET_LABOR_RATES_RESPONSE',
  SET_INVALID_QUOTE_ETAG_MESSAGE = 'SET_INVALID_QUOTE_ETAG_MESSAGE',
  SET_SKILL_OVERRIDE = 'SET_SKILL_OVERRIDE',
  RESET_SKILL_OVERRIDES = 'RESET_SKILL_OVERRIDES',
  FETCH_SKILL_LEVEL_OPTIONS = 'FETCH_SKILL_LEVEL_OPTIONS',
  RECEIVE_SKILL_LEVEL_OPTIONS = 'RECEIVE_SKILL_LEVEL_OPTIONS',
}
